import React from 'react';

import report_a_bug_btn from './images/report-a-bug-btn.png';
import report_a_bug_modal from './images/report-a-bug-modal.png';

export default function ReportABugDocs() {
	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Report a Bug</div>
			<div className='documentation-container'>
				<h2 className='documentation-page-heading'>Reporting bugs</h2>
				<div className='documentation-step-text'>On any screen in the app, click the floating bug icon (<span><img className='documentation-inline-image' src={report_a_bug_btn} alt='report a bug button'/></span>) on the right side of the screen.</div>
				<div className='documentation-step-text'>This should open up a popup where you can report an issue. This goes directly to our development team who will work on resolving this as quickly as possible.</div>
				<img id='getting-started-image' src={report_a_bug_modal} alt='report a bug modal'/>
				<div className='documentation-step-text'>If you have an urgent issue, please reach out to us at contact@edario.com.</div>
			</div>
		</div>
	);
}
